module.exports = __webpack_public_path__ + "img/geofisica_16-9.77ba1507.webp";